import { render, staticRenderFns } from "./TopSellingProducts.vue?vue&type=template&id=088cbbfa&scoped=true"
import script from "./TopSellingProducts.vue?vue&type=script&lang=js"
export * from "./TopSellingProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088cbbfa",
  null
  
)

export default component.exports